import { IntegrationProviders } from 'app-constants'
import { IUserObject, IntegrationButtonProps, IIntegrationData, IIntegrationSyncResourceTypes } from 'types'
import api from 'helpers/api'
import { ITableDetails } from 'components/spreadsheet/types'

export const syncIntegration = (
  user: IUserObject | undefined,
  provider: IntegrationProviders,
  props: IntegrationButtonProps,
  dataType: IIntegrationSyncResourceTypes,
  syncingIntegration: boolean,
  setSyncingIntegration: (syncing: boolean) => void,
  tablePublicId: string,
  onSuccess: () => void,
  onFailure: (error: any) => void,
  updateIntegration: boolean
) => {
  if (user && !syncingIntegration) {
    setSyncingIntegration(true)
    const data: IIntegrationData = getDataForProvider(provider, props, dataType)
    api
      .syncIntegration(tablePublicId, provider, data, updateIntegration)
      .then(() => {
        onSuccess()
      })
      .catch((e) => {
        onFailure(e)
      })
  }
}

const getDataForProvider = (
  provider: IntegrationProviders,
  props: IntegrationButtonProps,
  dataType: IIntegrationSyncResourceTypes
) => {
  if (provider === IntegrationProviders.MORTA) {
    const syncFields: Record<string, string[]> = {}
    if (props.projects && props.projects.length > 0) {
      syncFields['morta_project_ids'] = props.projects
    }
    if (props.views && props.views.length > 0) {
      syncFields['morta_view_ids'] = props.views
    }
    return {
      syncFields,
      syncAllHubs: props.syncAllHubs ?? false,
      type: dataType
    }
  }

  // All other providers use generic sync_fields format
  // Props come directly from IntegrationFieldSelector with field keys (hub_id, project_id, etc.)
  const syncFields: Record<string, string | string[] | undefined> = {}
  Object.entries(props).forEach(([key, value]) => {
    if (key !== 'projects' && key !== 'views' && value !== undefined && value !== '') {
      syncFields[key] = value
    }
  })

  return {
    syncFields,
    type: dataType
  }
}

export const getIsProviderSynced = (provider: IntegrationProviders, tableDetails: ITableDetails) => {
  if (tableDetails && tableDetails.isSynced && tableDetails.syncType && tableDetails.syncProvider === provider)
    return true
  return false
}
